<template>
  <div class="cabinet-login-header">
    <div class="logo">
      <a :href="url_main" target="_blank">
        <img src="/assets/images/logo_tradeview-red-white.svg" alt />
      </a>
    </div>
    <div class="options">
      <!--      <button @click="contactUsClicked">Contact us</button>-->
      <a v-if="region === 'mena'" href="https://tradeviewmena.com/contact" target="_blank" class="links">{{ $t('loginHeader.contactUs') }}</a>
      <a v-else :href="pageContact" target="_blank" class="links">{{ $t('loginHeader.contactUs') }}</a>
      <!--<div class="pipe">|</div>-->
      <SelectLanguage class="cabinet-login-language" v-model="language"></SelectLanguage>
    </div>
  </div>
</template>

<script>

import SelectLanguage from "@/components/SelectLanguage";

export default {
  name: "LoginHeader",
  components: {
    SelectLanguage
  },
  data() {
    return {
      language: 'en',
      url_main: process.env.TV_PAGE,
      pageContact: process.env.VUE_APP_TRADEVIEW_INDEX + 'contact',
      region: process.env.VUE_APP_CABINET_ORIGIN
    }
  },
  mounted() {
    this.language = this.$i18n.locale
  },
  watch: {
    language() {
      this.changeLocale(this.language);
    }
  },
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale
    },
    contactUsClicked() {
      // console.log('contactUsClicked()');
    }
  }
}
</script>
